<!-- Main Content Card -->
<div class="content-card">
  <div class="card-header with-button">
    <h3 class="card-title">
      <svg>
        <use href="assets/icons.svg#person"></use>
      </svg>
      Customer Details
    </h3>
    <button class="btn btn-primary btn-small" (click)="runSpeedTest()">Run Speed Test</button>
  </div>

  <div class="card-content">
    <form class="customer-form" [formGroup]="customerForm" [class.disabled]="customerForm.disabled">
      <div class="card-intro">
        <svg>
          <use href="assets/icons.svg#person"></use>
        </svg>
        <p>Enter customer details for the broadband application</p>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="firstName" class="field-label">First Name *</label>
          <input
            type="text"
            class="form-input"
            name="firstName"
            placeholder="John"
            formControlName="firstName"
          />
        </div>

        <div class="form-field">
          <label for="lastName" class="field-label">Last Name *</label>
          <input
            type="text"
            class="form-input"
            name="lastName"
            placeholder="Doe"
            formControlName="lastName"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="address" class="field-label">Address *</label>
          <input
            type="text"
            class="form-input"
            name="address"
            placeholder="House number and street name"
            formControlName="address"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="addressLine1" class="field-label">Address Line 1</label>
          <input
            type="text"
            class="form-input"
            name="addressLine1"
            placeholder="Apartment, suite, unit etc."
            formControlName="addressLine1"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="addressLine2" class="field-label">Address Line 2</label>
          <input
            type="text"
            class="form-input"
            name="addressLine2"
            formControlName="addressLine2"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="postcode" class="field-label">Postcode *</label>
          <input
            type="text"
            class="form-input"
            name="postcode"
            placeholder="12345"
            [class.invalid]="
              customerForm.controls.postcode.touched && customerForm.controls.postcode.invalid
            "
            formControlName="postcode"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="country" class="field-label">Country *</label>
          <input type="text" class="form-input" name="country" formControlName="country" />
        </div>
      </div>

      <br />
      <br />

      <div class="form-row">
        <div class="form-field">
          <label for="billingName" class="field-label">Billing Name *</label>
          <input type="text" class="form-input" name="billingName" formControlName="billingName" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="billingAddress" class="field-label">Billing Address *</label>
          <input
            type="text"
            class="form-input"
            name="billingAddress"
            formControlName="billingAddress"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="billingSortCode" class="field-label">Billing Sort Code *</label>
          <input
            type="text"
            class="form-input"
            name="billingSortCode"
            formControlName="billingSortCode"
          />
        </div>

        <div class="form-field">
          <label for="billingIBAN" class="field-label">Billing IBAN *</label>
          <input type="text" class="form-input" name="billingIBAN" formControlName="billingIBAN" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="billingDOB" class="field-label">Date of birth *</label>
          <input type="date" class="form-input" name="billingDOB" formControlName="billingDOB" />
        </div>
      </div>
    </form>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn btn-secondary" type="button" (click)="goBack()">Back</button>
      <button
        type="submit"
        [disabled]="!customerForm.valid"
        class="btn btn-primary"
        (click)="sendOffer()"
      >
        Continue
      </button>
    </div>
  </div>
</div>
